/* -----------------Globals--------------- */
import { pageViewTypes } from "@constants/tracking";
import PracticeTestsContainer from "@features/dashboard/screens/PracticeTestsContainer";
import useAnalytics from "@hooks/useAnalytics";
import DocumentTitle from "components/DocumentTitle";
import { Stack } from "expo-router";
import { useMemo } from "react";

/* -----------------Child components--------------- */

const DrawerPracticeTestsRoute = () => {
	const memoizedAnalyticsParams = useMemo(() => {
		return {
			type: pageViewTypes.practiceTest,
		};
	}, []);
	useAnalytics(memoizedAnalyticsParams);

	return (
		<>
			<Stack.Screen
				options={{
					header: () => null,
				}}
			/>

			<DocumentTitle title="Practice Tests" />
			<PracticeTestsContainer />
		</>
	);
};

export default DrawerPracticeTestsRoute;
